import { useEffect } from "react";
import { LegalPage } from "@/components/landing/LegalPage";

export default function Impressum() {
  useEffect(() => {
    document.title = "Impressum — Positivup";
  }, []);
  return <LegalPage doc="impressum" />;
}
